<template>
  <div class="list-container">
    <div v-show="!dialogFormVisible">
      <div class="filter-container">
        <template v-if="!isFilterCollapse">
          <div class="filter-box">
            <span class="label">公司名称</span>
            <el-input
              v-model="listQuery.companyName"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>

          <div class="filter-box">
            <span class="label">业务代表</span>
            <el-select :filterable="true" v-model="listQuery.salesManId" class="filter-item" placeholder="" clearable :size="t('table.btnSize')" @focus="handleSalesManFocus" @change="handleFilter">
              <el-option
                v-for="item in salesManOption"
                :key="item.id"
                :label="item.mark"
                :value="item.id"
              />
            </el-select>
          </div>
          <div class="filter-box">
            <span class="label">业务编号</span>
            <el-input
              v-model="listQuery.businessNo"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">审批状态</span>
            <el-select :filterable="true" v-model="listQuery.changeStatus" class="filter-item" placeholder="" clearable :size="t('table.btnSize')" @keyup.enter="handleFilter">
              <el-option
                v-for="item in ReviewStatusOption"
                :key="item.id"
                :label="item.mark"
                :value="item.id"
              />
            </el-select>
          </div>
          <div class="filter-box">
            <span class="label">开始日期</span>
            <el-date-picker
              v-model="listQuery.startTime"
              type="date"
              placeholder=" "
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              @keyup.enter="handleFilter"
              :size="t('table.btnSize')"
            >
            </el-date-picker>
          </div>
          <div class="filter-box">
            <span class="label">结束日期</span>
            <el-date-picker
              v-model="listQuery.endTime"
              type="date"
              placeholder=" "
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              @keyup.enter="handleFilter"
              :size="t('table.btnSize')"
            >
            </el-date-picker>
          </div>
        </template>
        <div class="filter-box">
          <el-button
            v-waves
            class="filter-item "
            type="primary"
            :size="t('table.btnSize')"
            @click="handleFilter"
          >
            {{ t("table.search") }}
          </el-button>
          <el-button
            v-permission="{ pkey: `${permissionName}_ADD` }"
            class="filter-item"
            type="primary"
            :size="t('table.btnSize')"
            @click="handleCommand('add')"
          >
            {{ t("table.add") }}
          </el-button>
          <el-button
            v-waves
            class="filter-item"
            :size="t('table.btnSize')"
            @click="handleReset"
          >
            {{ t("table.reset") }}
          </el-button>
          <el-button
            v-waves
            class="filter-item"
            :size="t('table.btnSize')"
            @click="isFilterCollapse = !isFilterCollapse"
          >
            {{isFilterCollapse ? '展开' : '收起'}}
          </el-button>
          <span class="svg-icon cursor mr-10 ml-10" @click="handleCommand('refresh')" >
            <i class="icon-tubiao-27 iconfont"/>
          </span>
          <span class="svg-icon cursor" @click="handleCommand('column')">
            <i class="icon-tubiao-28 iconfont"/>
          </span>
        </div>
      </div>
      <TableList
       ref="tableListRef"
        v-loading="listLoading"
        :dataList="list"
        :columnAllData="columnAllData"
        :tableName="TableName"
        :permissionName="permissionName"
        :isShowPagination="false"
        :canRefresh="false"
        :canChangeColumn="false"
        @command-change="handleCommand"
      >
        <template v-slot:operation-action="scope">
          <el-link
            v-permission="{ pkey: `${permissionName}_APPROVAL` }"
            v-if="listQuery.changeStatus !== 3"
            href="javascript:void(0);"
            class="mr-10"
            type="primary"
            @click="handleCommand('edit', scope.row)"
          >
            审批
          </el-link>
        </template>
      </TableList>
      <el-pagination
        class="mt-20"
        v-show="total > 0"
        :total="total"
        v-model:currentPage="listQuery.page"
        :page-size="listQuery.size"
        :page-sizes="pageSizes"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next"
      />
    </div>
    <div v-if="dialogFormVisible">
      <div style="display:flex">
        <FormComponent
          :id="activeId"
          :api="'businessMarketFee'"
          :detail="activeRow"
        />
      </div>
      <div class="dialog-footer mt-20">
        <el-button @click="dialogFormVisible = false" >
          {{ t("table.cancel") }}
        </el-button>
        <el-button
          type="primary"
          :loading="submitLoading"
          @click="handleSubmit"
        >
          通过当前
        </el-button>
        <el-button
          type="primary"
          :loading="submitLoading"
          @click="handleSubmit('all')"
        >
          通过该业务全部
        </el-button>
        <el-button
          type="danger"
          :loading="submitLoading"
          @click="handleReject"
        >
          拒绝
        </el-button>
      </div>
    </div>
  </div>
</template>

<script lang='ts'>
import { defineComponent, reactive, toRefs, onMounted, ref } from 'vue'
import { cloneDeep } from 'lodash'
import { ElMessage, ElMessageBox } from 'element-plus'

// import {  reviewApprove, reviewReject } from '@/apis/OutsourceFee'
import { getDropdown, getPageList, reviewApprove, reviewReject, putUrl, getDetailById } from '@/apis/Dictionary'
import { getPageList as getUrlList } from '@/apis/Form'

import { CostModel, ArrayRowsItem } from '@/model/Index'

import FormComponent from './Form.vue'

import TableList from '@/components/common/TableList.vue'
import { TableName, permissionName } from '@/utils/enum'
import { FromFieldData } from '@/views/business/outsourceCompany/accountInfo/FieldFrom'
import { TableField } from './FieldTable'
import mixin from '@/mixins/index'
import { defaultDate, pageVo, pageSizes } from '@/utils/index'
import { getDropdownByType } from '@/apis/tool'

import { useI18n } from 'vue-i18n'
export default defineComponent({
  name: 'Approvaloutsourcefee',
  components: {
    FormComponent,
    TableList
  },
  setup() {
    const { t } = useI18n()
    const tableListRef = ref(null)
    const dataMap = reactive({
      TableName: TableName.TABLE_APPROVAL_MARKET_FEE,
      permissionName: permissionName.APPROVAL_MARKET_FEE,
      initFormData: cloneDeep(FromFieldData),
      originFromFieldData: cloneDeep(FromFieldData),
      targetFromFieldData: cloneDeep(FromFieldData),
      columnAllData: TableField,

      activeId: 0,
      activeRow: null,
      list: [],
      total: 0,
      listLoading: false,
      listQuery: {
        businessNo: undefined,
        businessName: undefined,
        businessModel: undefined,
        outsourceCompany: undefined,
        salesManId: undefined,
        invoiceStatus: undefined,
        startTime: '',
        endTime: '',
        ...pageVo,
        changeStatus: undefined
      },
      pageSizes,
      dialogFormVisible: false,

      salesManOption: [],
      statusOption: [],
      ReviewStatusOption: [],
      UserPayTypeOption: [],
      submitLoading: false,
      handleCommand(command: string, val?: any) {
        switch (command) {
          case 'edit':
            dataMap.handleUpdate(val)
            break
          case 'refresh':
            dataMap.handleFilter()
            break
          case 'column':
            (tableListRef.value as any).setColumnVisible = true
            break
          case 'current-change':
            dataMap.handleCurrentChange(val)
            break
          case 'size-change':
            dataMap.handleSizeChange(val)
            break
        }
      },
      getList() {
        dataMap.listLoading = true
        getPageList('businessMarketFee', { ...dataMap.listQuery, status: 2, feeType: 2 }).then((res: any) => {
          dataMap.list = res.data
            ? res.data.map((item: any) => {
              return {
                ...item,
                customerCompany: item.business.customerCompany,
                ticketCompany: item.business.ticketCompany,
                businessNo: item.business.no,
                businessName: item.business.name,
                businessBrand: item.business.brand,
                businessAmount: item.business.amount,
                businessModel: item.business.model,
                businessSerial: item.business.serial,
                businessUnit: item.business.unit
              }
            })
            : []
          dataMap.total = res.total || 0
          dataMap.listLoading = false
        }).catch(() => {
          dataMap.listLoading = false
        })
      },
      handleReset() {
        dataMap.listQuery = {
          businessNo: undefined,
          businessName: undefined,
          businessModel: undefined,
          outsourceCompany: undefined,
          salesManId: undefined,
          invoiceStatus: undefined,
          startTime: defaultDate[0],
          endTime: defaultDate[1],
          ...pageVo,
          changeStatus: undefined
        }
        dataMap.handleFilter()
      },
      handleFilter() {
        dataMap.getList()
      },

      handleUpdate(row: any) {
        dataMap.activeId = row.id
        // dataMap.activeRow = row
        // dataMap.dialogFormVisible = true
        getDetailById('businessMarketFee', row.id).then((res: any) => {
          dataMap.activeRow = res
          console.log(dataMap.activeRow, 333)
          dataMap.dialogFormVisible = true
        })
      },
      handleCurrentChange(page?: any) {
        dataMap.listQuery.page = page
        dataMap.getList()
      },
      handleSizeChange(size: any) {
        dataMap.listQuery.size = size
        dataMap.handleCurrentChange(1)
      },
      loadDropdownList(url: string) {
        getDropdown(url).then((res: any) => {
          dataMap[`${url}Option`] = res
        })
      },
      handleReject() {
        ElMessageBox.prompt(
          '拒绝理由：',
          '提交',
          {
            confirmButtonText: t('table.confirm'),
            cancelButtonText: t('table.cancel'),
            cancelButtonClass: 'el-button--danger'
          }
        ).then((params: any) => {
          const { value } = params
          reviewReject('businessMarketFee', dataMap.activeId, { comment: value }).then(() => {
            dataMap.dialogFormVisible = false
            dataMap.getList()
            ElMessage.success('操作成功！')
          })
        })
      },
      async handleSubmit(type?: string) {
        try {
          if (type === 'all') {
            const businessId = (dataMap.activeRow as any).business.id
            await putUrl(`businessMarketFee/actions/review/approve/all/${businessId}`)
          } else {
            await reviewApprove('businessMarketFee', dataMap.activeId)
          }
          dataMap.dialogFormVisible = false
          dataMap.getList()
          ElMessage.success('操作成功！')
        } catch (err:any) {
          console.log(err, 'err')
        }
      },
      handleSalesManFocus() {
        getUrlList('user/dropdown/salesman').then((res: any) => {
          dataMap.salesManOption = res || []
        })
      },
      getDropdownByType(url: string) {
        getDropdownByType('ReviewStatus').then((res: any) => {
          dataMap[`${url}Option`] = res
        })
      }
    })
    const { mixinData } = mixin(dataMap)

    onMounted(async() => {
      dataMap.listQuery.startTime = defaultDate[0]
      dataMap.listQuery.endTime = defaultDate[1]
      dataMap.getList()
      dataMap.getDropdownByType('ReviewStatus')
    })
    return { t, ...toRefs(dataMap), ...toRefs(mixinData), tableListRef }
  }
})
</script>
<style  lang="scss" scope>
.statusStyle{
  .status{
    // border: 1px solid;
    padding: 0 4px;
    border-radius: 6px;
    margin-right: 7px;
    font-size: 10px;
    color:#fff;
  }
}
.redStatusStyle{
  .icon-tubiao-40{
    color:#E74228;
  }
  .status{
    background-color:#E74228;
  }
}
.yellowStatusStyle{
  .icon-tubiao-40{
    color:#F3D03C;
  }
  .status{
    background-color:#F3D03C;
  }
}
</style>
